import React from "react";
import { Table } from "react-bootstrap";
import "./VehicleSpecificationsSection.css";

export default function SpecificationTab({ category, variants }) {
    if (!category || !variants?.length) return null;

    return (
        <div className="spec-tab">
            <div className="spec-table__wrap">
                <Table responsive bordered hover className="spec-table">
                    <thead>
                        <tr>
                            <th className="spec-table__head-left">Specifications</th>
                            {variants.map((v) => (
                                <th key={v.id} className="spec-table__head">
                                    {v.name}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {(category.rows || []).map((row, idx) => (
                            <tr key={`${category.id}-${idx}`}>
                                <td className="spec-table__label">{row.label}</td>
                                {variants.map((v) => (
                                    <td key={v.id} className="spec-table__value">
                                        {row?.values?.[v.id] ?? "—"}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}
